import { PrismaEnums } from '@airreading/schema/browser';
import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

import { fullClassTimeSchema } from './class-time.js';
import { dayOfWeekSchema } from './meeting-block.js';

export const coachAvailabilityTypeSchema = z.nativeEnum(PrismaEnums.CoachAvailabilityType);
export type CoachAvailabilityType = z.infer<typeof coachAvailabilityTypeSchema>;
export const CoachAvailabilityType = coachAvailabilityTypeSchema.enum;

export const minimalAvailabilitySchema = z.object({
  day: dayOfWeekSchema,
  startPlainTime: z.instanceof(Temporal.PlainTime),
  endPlainTime: z.instanceof(Temporal.PlainTime),
});
export type MinimalAvailability = z.infer<typeof minimalAvailabilitySchema>;

export const coachAvailabilitySchema = z
  .object({
    id: z.string(),
    userId: z.string(),
    updatedAt: z.instanceof(Temporal.Instant),
  })
  .extend(minimalAvailabilitySchema.shape)
  .extend({
    type: coachAvailabilityTypeSchema,
  });
export type CoachAvailability = z.infer<typeof coachAvailabilitySchema>;

export const classEligibilitySchema = z.enum([
  'can_teach_intervention',
  'can_teach_practice',
  'can_teach_diagnostic',
  'air_crew',
  'imported_from_v1',
]);
export type ClassEligibility = z.infer<typeof classEligibilitySchema>;
export const ClassEligibility = classEligibilitySchema.enum;

export const coachAvailabilityFromFilterSchema = z.object({
  classTimes: z.union([z.lazy(() => z.array(fullClassTimeSchema)), z.array(z.string())]),
  orgId: z.string(),
  classEligibilities: z.array(classEligibilitySchema).optional(),
  overrideStartPlainDate: z.instanceof(Temporal.PlainDate).optional(),
  overrideEndPlainDate: z.instanceof(Temporal.PlainDate).optional(),
  shouldAvoidConflicts: z.boolean().optional(),
});
export type CoachAvailabilityFromFilter = z.infer<typeof coachAvailabilityFromFilterSchema>;
